import React, { useEffect, useState } from "react";
import "./css/allGames.css";
import Layout from "./layout/Layout";
import { useNavigate, useParams } from "react-router-dom";
import gameConfig from "../utils/gamesConfig";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./css/carousel.css";
import {
  service,
  footerImages,
  backgroundImages,
  getSectionBackgroundStyle,
  PopupSub,
} from "../utils/constant";
import { useTranslation } from "react-i18next";
import { checkStatus, updateRenewalStatus } from "../services/user-api";

const CATEGORY_LABEL_KEYS = {
  Sports: "sport",
  Funny: "funny",
  Action: "action",
  Adventure: "adventure",
  Racing: "racing",
  Kids: "kids",
  Puzzle: "puzzle",
  Android: "android",
};

const AllGames = () => {
  const { t } = useTranslation("global");
  const navigate = useNavigate();
  const { categoryName } = useParams();
  const [subStatus, setSubStatus] = useState(0);
  const [popup, setPopup] = useState(false);

  let filterGames = categoryName
    ? gameConfig.find((item) => item.category_name === categoryName)
    : gameConfig.map((item) => item);

  let games = categoryName
    ? filterGames.games
    : [
        ...filterGames[0].games,
        ...filterGames[1].games,
        ...filterGames[2].games,
        ...filterGames[3].games,
        ...filterGames[4].games,
        ...filterGames[5].games,
        ...filterGames[6].games,
      ];

  const topTenSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    responsive: [
      {
        breakpoint: 768, // Adjust the breakpoint as needed
        settings: {
          slidesToShow: 2, // Show 2 slides at a time on mobile devices
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1196, // Adjust the breakpoint as needed
        settings: {
          slidesToShow: 3, // Show 2 slides at a time on mobile devices
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1400, // Adjust the breakpoint as needed
        settings: {
          slidesToShow: 4, // Show 2 slides at a time on mobile devices
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handlePlayGame = (input) => {
    setPopup(false);
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    }
    else
    {
      if (input !== null && input !== undefined && input.length > 2) {
        window.location.href = input;
      } else {
        navigate("/allGames");
      }
    }
    /* else {
      checkStatus()
        .then((res) => {
          if (res.data.data === 206) {
            setSubStatus(res.data.data);
            setPopup(true);
          } else if (input !== null && input !== undefined && input.length > 2) {
            window.location.href = input;
          } else {
            navigate("/allGames");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }*/
  };

  const handleDownload = (gameUrl) => {
    setPopup(false);
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    }
    else
    {const gameName = gameUrl.split("/");
      const link = document.createElement("a");
      link.href = gameUrl;
      link.download = gameName[gameName.length - 1];
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    /*else {
      checkStatus()
        .then((res) => {
          if (res.data.data === 206) {
            setSubStatus(res.data.data);
            setPopup(true);
          } else {
            const gameName = gameUrl.split("/");
            const link = document.createElement("a");
            link.href = gameUrl;
            link.download = gameName[gameName.length - 1];
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }*/
  };

  const renewalStatus = async (input) => {
    await updateRenewalStatus({ status: input })
      .then((res) => {
        setPopup(false);
        console.log(res);
      })
      .catch((err) => {
        setPopup(false);
        console.log(err);
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    } /*else {
      checkStatus()
        .then((res) => {})
        .catch((err) => {
          console.log(err);
        });
    }*/
  }, []);

  return (
    <Layout>
      <div className="games_page page_shell">
        <section
          className="intro_part intro_part--compact section_bg"
          style={getSectionBackgroundStyle(backgroundImages.hero, {
            overlay: 0.78,
            position: "center top",
          })}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 col-lg-8">
                <div className="intro_text_container">
                  <span className="section_eyebrow">
                    {categoryName
                      ? t(`portalText.${CATEGORY_LABEL_KEYS[categoryName] || "play"}`)
                      : t("portalText.play")}
                  </span>
                  {service === "mueg" ? (
                    <h2>
                      Muni <span>Game</span>
                    </h2>
                  ) : service === "mng" ||
                    service === "mtg" ||
                    service === "mgb" ? (
                    <h2>
                      MOOV <span>GAMES</span>
                    </h2>
                  ) : (
                    <h2>
                      GS <span>GAMES</span>
                    </h2>
                  )}
                  <p>
                    {service === "ogb" ? (
                      <>
                        {t("portalText.ogbDesc")}
                        <img
                          className="ogMoney"
                          src="/images/ogg.png"
                          alt="GSGames"
                        />
                        {t("portalText.ogbDesc1")}
                      </>
                    ) : service === "mng" ? (
                      t("portalText.mngDesc")
                    ) : service === "mtg" ? (
                      t("portalText.mtgDesc")
                    ) : service === "mgb" ? (
                      t("portalText.mgbDesc")
                    ) : service === "mueg" ? (
                      t("portalText.muegDesc")
                    ) : (
                      t("portalText.desc")
                    )}
                  </p>
                  <button
                    type="button"
                    className="btn_catalog_play"
                    onClick={() => handlePlayGame(null)}
                  >
                    <i className="fas fa-play" />
                    {t("portalText.play")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="games_wrapper section_bg"
          style={getSectionBackgroundStyle(backgroundImages.catalog, {
            overlay: 0.88,
          })}
        >
          <div className="container section_block section_block--tight">
            <div className="catalog_header">
              <div>
                <h3 className="section_title">
                  {categoryName
                    ? t(`category.${categoryName}`)
                    : t("portalText.play")}
                </h3>
              </div>
              <div className="catalog_count">
                <i className="fas fa-gamepad" />
                {t("Total")}: {games.length}
              </div>
            </div>
            <div className="games_grid">
              {!!games.length &&
                games.map((game, i) => (
                  <div className="game_box" key={i}>
                      <div className="game_top_container">
                        <img src={game?.image} alt="game" />
                        <div className="game_top_link">
                          {categoryName !== "Android" ? (
                            <button
                              type="button"
                              onClick={() => handlePlayGame(game?.path)}
                            >
                              {t("LetPlay")}
                            </button>
                          ) : (
                            <button
                              type="button"
                              onClick={() => handleDownload(game?.path)}
                            >
                              {t("portalText.download")}
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="game_detail">
                        <div className="game_title_box">
                          <div className="game_title">
                            {t("allGames." + game?.name)}
                          </div>
                          <div>
                            <img
                              src="/images/flag_circle.png"
                              alt="flag circle"
                            />
                          </div>
                        </div>
                        <div className="game_description">
                          {game?.description}
                        </div>
                      </div>
                    </div>
                ))}
            </div>
          </div>
        </section>
        <section className="brand_list brand_list_footer">
          <div className="container">
            <div className="row align-items-center">
              {/* <div className='col-12 col-lg-4 d-none d-lg-block'>
                                <p>Trusted By Brands Worldwide:</p>
                            </div> */}
              <div className="col-12 col-lg-12">
                <Slider {...topTenSettings}>
                  {footerImages.map((brand, index) => (
                    <img
                      key={`FooterSlide ${index + 1}`}
                      src={brand.src}
                      alt={brand.name}
                    />
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </section>
        <footer className="site_footer">
          <div className="container site_footer_inner">           
            <div className="site_footer_divider" />
            <p className="site_footer_copy">
              {service === "mueg"
                ? t("portalText.CopyrightMuni")
                : t("portalText.Copyright")}
            </p>
          </div>
        </footer>
      </div>
      {popup && (
        <PopupSub
          subStatus={subStatus}
          redirectTo={renewalStatus}
          detail={t("portalText.RenewalConsent")}
          confirm={t("portalText.RenewalConsent1")}
          yes={t("portalText.YES")}
          no={t("portalText.NO")}
        />
      )}
    </Layout>
  );
};

export default AllGames;
